import React from "react";
import {StatePopupWrapperBox} from "./boxes/state-popup-wrapper.box";
import {CyClass} from "../../../common/cy-classes";
import { ModalDialogActionsComponent } from "../modal-dialog/modal-dialog-actions.component";
import { DialogTextBox } from "../modal-dialog/boxes/text/dialog-text.box";
import {OrbitComponentWithState} from "../base-components/orbit-component-with-state/orbit-component-with-state";
import {IStatePopupComponentProps} from "./state-popup.component";
import {StatePopupErrorMessageBox} from "./boxes/state-popup-error-message.box";
import {StatePopupSelectWrapperBox} from "./boxes/state-popup-select-wrapper.box";
import {Select} from "../../basic-ui-components/form/select.component";

interface IStatePopupWithDropdownComponentState {
    currentStateID: string;
    shouldShowError: boolean;
}

export class StatePopupWithDropdownComponent extends OrbitComponentWithState<IStatePopupComponentProps, IStatePopupWithDropdownComponentState> {

    constructor(props) {
        super(props);
        this.state = {
            currentStateID: this._defaultOption,
            shouldShowError: false
        };
    }

    componentDidMount() {
        super.componentDidMount();
        this.setState({
            currentStateID: this.services.stateOfResidenceIdentifier.getUserSelectedState() || this._defaultOption
        });
    }

    private readonly _defaultOption = "DEFAULT_OPTION";

    private _onStateConfirmation = () => {
        if (this.state.currentStateID === this._defaultOption) {
            this.setState({
               shouldShowError: true
            });
            return;
        }

        this.props.onStateSelect(this.state.currentStateID);
        this._closeDialogBox();
    };

    private _onStateNotInListClick = () => {
        this.props.onStateNotInListClick();
    };

    private _closeDialogBox = () => {
        this.props.dialogHandler && this.props.dialogHandler.close();
    };

    private _updateSelection = (selection: string): void => {
        return this.setState({
            currentStateID: selection,
            shouldShowError: selection === this._defaultOption
        });
    };

    private _renderStateSelector() {
        if (!this.services.stateOfResidenceIdentifier.isOneSiteEnabled()) {
            return null;
        }

        return (
            <Select onChange={e => this._updateSelection(e.target.value)}
                       value={this.state.currentStateID}
                    width="100%">
                {this._renderOptions()}
            </Select>
        );
    }

    private _renderOptions = (): JSX.Element[] => {
        const defaultOption = <option key={this._defaultOption} value={this._defaultOption} hidden={true}>
            {this.services.translation.translate("STATE_POPUP_DEFAULT_OPTION")}
        </option>;

        const stateOptions = this.services.stateOfResidenceIdentifier.getSupportedStates().map(sr =>
            <option key={sr.ID} value={sr.ID}>
                {sr.Name}
            </option>
        );

        return [defaultOption, ...stateOptions];
    }

    private _renderErrorMessage = () => {
        if (!this.state.shouldShowError) {
            return null;
        }

        return <StatePopupErrorMessageBox>
            {this.services.translation.translate("STATE_POPUP_NO_STATE_SELECTED")}
        </StatePopupErrorMessageBox>;
    }

    render() {

        return (
            <StatePopupWrapperBox>
                <DialogTextBox>{this.services.translation.translate("CHOOSE_CONFIRM_STATE")}</DialogTextBox>
                <StatePopupSelectWrapperBox>
                    {this._renderStateSelector()}
                    {this._renderErrorMessage()}
                </StatePopupSelectWrapperBox>
                <ModalDialogActionsComponent primaryAction={{
                    text: this.services.translation.translate("STATE_POPUP_CONFIRM"),
                    onClick: this._onStateConfirmation,
                    className: CyClass('cy-state-select-approve-button')
                }} linkAction={{
                    onClick: this._onStateNotInListClick,
                    text: this.services.translation.translate("STATE_POPUP_OTHER_STATE")
                }} />
            </StatePopupWrapperBox>
        );
    }
}
//text: this.services.translation.translate("STATE_POPUP_OUTSIDE_TEXT", {THE_STATE: stateName})